import React from "react";

import WarningIcon from "@mui/icons-material/Warning";
import { Box, Button, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import Dialog from "@/components/Dialog";
import Padding from "@/components/layout/Padding";
import { colors } from "@/theme/overrides/colors";

interface Props {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles()({
  paper: {
    minWidth: 400,
    maxWidth: 400,
  },
  content: {
    paddingTop: 0,
  },
  icon: {
    maxHeight: 60,
    fontSize: 60,
    color: colors.secondary,
  },
  title: {
    fontWeight: 700,
    fontSize: 28,
    lineHeight: 1,
    color: colors.dark,
    textAlign: "center",
  },
  message: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "22px",
    color: colors.grey,
    textAlign: "center",
  },
  button: {
    minWidth: 125,
  },
});

const AttachmentErrDialogExtension: React.FC<Props> = (props) => {
  const { classes } = useStyles();
  return (
    <Dialog
      {...props}
      classes={{ paper: classes.paper }}
      contentClassName={classes.content}
      content={
        <Box display="flex" margin="8px" alignItems="center">
          <Box display="flex" margin={9} alignItems="center">
            <div className={classes.icon}>
              <WarningIcon fontSize="inherit" color="inherit" />
            </div>
            <Typography className={classes.title}>
              File type not supported
            </Typography>
          </Box>
          <Padding horizontal={4}>
            <Typography className={classes.message}>
              Here&apos;s the file types you can upload ( .doc .docx .xls .xlsx
              .ppt .pptx .pdf .jpg .png .mp4)
            </Typography>
          </Padding>
        </Box>
      }
      actions={
        <Button size="large" className={classes.button} onClick={props.onClose}>
          OK
        </Button>
      }
    />
  );
};

export default AttachmentErrDialogExtension;
